import { PageHeaderStatic } from '@procureai/ui-mui';
import { useParams } from 'react-router-dom';

import { AstroSmartLinkDomain } from '@/generated/gql/graphql';
import { useSmartLinks } from '~/components/SmartLinksNavList/hooks/useSmartLinks';

import { SmartLinkIFrame } from './SmartLinkIFrame/SmartLinkIFrame';
import { SmartLinksContainer } from './SmartLinks.styled';
import { SmartLinksExternalButton } from './SmartLinksExternalInfo/SmartLinksExternalButton';
import { SmartLinksExternalInfo } from './SmartLinksExternalInfo/SmartLinksExternalInfo';

interface SmartLinksProps {
  domain: AstroSmartLinkDomain;
}

export const SmartLinks = ({ domain }: SmartLinksProps) => {
  const { id } = useParams() as { id?: string };
  const { smartLinks } = useSmartLinks({ domain });

  const link = smartLinks.find((link) => link.id === id);

  if (!link) {
    return null;
  }

  return (
    <SmartLinksContainer>
      <PageHeaderStatic maxWidth={false} title={link.title} right={<SmartLinksExternalButton href={link.url} />} />
      {link.external ? <SmartLinksExternalInfo href={link.url} /> : <SmartLinkIFrame url={link.url} />}
    </SmartLinksContainer>
  );
};
